import React, { useMemo } from "react";
import { ApolloConsumer } from "@apollo/client";
import ReactTooltip from "react-tooltip";
import { RenderDate } from "../CaseDetailUtils";
import NoDataComponent from "./../../../../components/Table/TableComponents/NoDataComponent";
import "./../../../../components/Cases/cases.scss";
import "./CaseDocumentsTable.scss";
import moment from "moment-timezone";

import { Styles } from "../../../../global/css/component/Table";
import { ReactTable } from "../../../SimpleForm/ReactTable/index.js";

function CaseDocumentsTable(props) {
  const { searchText, data } = props;

  const columns = useMemo(
    () => [
      {
        Header: "Case Number",
        accessor: "caseNumber",
        id: "caseNumber",
        fixedWidth: 175,
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`caseNumber${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`caseNumber${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Case Status",
        accessor: "externalStatus",
        id: "externalStatus",
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`externalStatus${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`externalStatus${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Date Submitted",
        accessor: "submittedDate",
        id: "submittedDate",
        fixedWidth: 150,
        Cell: ({ column: { id }, cell: { value }, row: { index } }) => {
          return RenderDate(value, index, id, moment.tz.guess(true));
        },
      },
      {
        Header: "Employer Name",
        accessor: "empBusinessName",
        id: "empBusinessName",
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`empBusinessName${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`empBusinessName${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Agent Name",
        accessor: "agentName",
        id: "agentName",
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`agentName${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip type="dark" effect="solid" id={`agentName${index}`}>
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Start Date of Need",
        accessor: "tempneedStart",
        id: "tempneedStart",
        fixedWidth: 170,
        Cell: ({ column: { id }, cell: { value }, row: { index } }) => {
          return RenderDate(value, index, id, "UTC");
        },
      },
      {
        Header: "End Date of Need",
        accessor: "tempneedEnd",
        id: "tempneedEnd",
        fixedWidth: 170,
        Cell: ({ column: { id }, cell: { value }, row: { index } }) => {
          return RenderDate(value, index, id, "UTC");
        },
      },
      {
        Header: "SWA State",
        accessor: "swaJoborderStatename",
        id: "swaJoborderStatename",
        fixedWidth: 120,
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`swaJoborderStatename${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`swaJoborderStatename${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Actively Linked",
        accessor: "isActive",
        id: "isActive",
        fixedWidth: 140,
        Cell: ({ cell: { value }, row: { index } }) => {
          const _value = value ? "Yes" : "No";
          return (
            <>
              <span data-tip data-for={`isActive${index}`}>
                {_value || "--"}
              </span>
              <ReactTooltip type="dark" effect="solid" id={`isActive${index}`}>
                <span>{_value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
    ],
    []
  );

  const NoDataConst = (props) => (
    <NoDataComponent noDataResult="There is no data for " {...props} />
  );

  return (
    <Styles>
      <ReactTable
        columns={columns}
        data={data}
        NoDataComponent={NoDataConst}
        searchText={searchText}
        pageSizeOptions={[10, 25, 50, 100]}
      />
    </Styles>
  );
}

export default (props) => (
  <ApolloConsumer>
    {(client) => (
      <CaseDocumentsTable
        style={{ width: "100%" }}
        apolloClient={client}
        {...props}
      />
    )}
  </ApolloConsumer>
);
